module.exports = __webpack_public_path__ + "assets/img/header.69703132.webp";